<template>
    <div class="visitor-typing">
        <div class="typing-dots">
            <div class="typing-dots-item"></div>
            <div class="typing-dots-item"></div>
            <div class="typing-dots-item"></div>
        </div>
        <div>{{ message }}...</div>
    </div>
</template>

<script>
import { log2 } from "../../../../../utils/log2";

const log = log2("VisitorTyping");
export default {
    name: "VisitorTyping",
    props: {
        message: {
            type: String,
            default: null,
        },
    },
};
</script>
<style lang="scss" scoped>
@keyframes wave {
    0% {
        transform: translateY(0px);
        opacity: 1;
    }
    50% {
        transform: translateY(-0.5rem);
        opacity: 0.4;
    }
    100% {
        transform: translateY(0px);
        opacity: 1;
    }
}

.visitor-typing {
    width: 100%;
    background: #22272d;
    padding: 6px 10px;
    color: white;
    display: flex;
    align-items: center;
    gap: 4px;
    .typing-dots {
        display: flex;
        align-items: center;
        gap: 5px;
        padding: 5px;
        border-radius: 20px;
        &-item {
            width: 6px;
            height: 6px;
            border-radius: 6px;
            animation: wave 1s infinite;
            background: white;
            &:nth-child(1) {
                animation-delay: 0.3s;
            }
            &:nth-child(2) {
                animation-delay: 0.6s;
            }
            &:nth-child(3) {
                animation-delay: 0.9s;
            }
        }
    }
}
</style>
